import React, { useContext, useState } from 'react';
import { Button } from '../../../atoms/button';
import { postGivingToTags } from '../donate-form-utils';
import { DonateFormContext } from '../DonateFormContext';
import styles from './PayPalButton.scss';

const PayPalButton = function PayPalButton() {
    const { formState, canSubmitForm, config } = useContext(DonateFormContext);
    const [isLoading, setIsLoading] = useState(false);

    const handleClick = async () => {
        setIsLoading(true);
        try {
            const compounduuid = await postGivingToTags(formState, config.charityKey);
            const orderRes = await fetch('/Services/PayPalCommerce/Order', {
                headers: {
                    'Content-Type': 'application/json',
                },
                method: 'POST',
                credentials: 'include',
                body: JSON.stringify(compounduuid),
            });

            if (!orderRes.ok) {
                window.location.assign('/Services/PayPalCommerce/Cancel');
                return;
            }

            const approveLink = await orderRes.json();
            window.location.assign(approveLink);
        } catch (e) {
            // do something here
        } finally {
            setIsLoading(false);
        }
    };

    if (formState.giving_frequency !== '1') {
        return null;
    }

    return (
        <Button
            id="donate-with-paypal"
            overrideClass={styles['paypal-button']}
            disabled={isLoading || !canSubmitForm}
            onClick={handleClick}
            isLoading={isLoading}
        >
            <div className={styles['paypal-button__content']}>
                <span>Donate with </span>
                <img alt="paypal-logo" className={styles['paypal-button__logo']} src="/images/Icons/paypal-logo.svg" />
            </div>
        </Button>
    );
};

export default PayPalButton;
